import React, { Component } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import AsideNavbar from '../components/navbars/AsideNavbar'
import Navbars from '../components/navbars/Navbars'
import * as Cookies from "es-cookie";

import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from 'lodash.flowright';
import { withRouter } from "react-router-dom";
import PreloaderTwo from '../components/preloader/PreloaderTwo';
import ChapterWiseQuestionsSection from '../components/ChapterWiseQuestions/ChapterWiseQuestionsSection';
import ShimmerLoader from '../components/preloader/ShimmerLoader';


const GET_CHAPTER_NAMES = gql`
query($exam_id:Int,$student_user_exam_id: Int!){
    getStateChapterNames(exam_id:$exam_id,student_user_exam_id: $student_user_exam_id){
        id
        subject_name
        state_chapters{
           id
        chapter_id
        class_id
        chapter_name
        enabled
        questionsCount
        previousChapterEnabled
        practiceEnabled
        revisionMaterialEnabled
        errorExamEnabled
        videoAccess
        }
      }
}
`;
const UPDATE_STUDENT_ANALYTICS = gql`
mutation(
  $params:AnalyticsStudents1  
  ) {
      studentAnalytics(
      params: $params
   )
}
`;

const GET_SUBJECTS = gql`
query($exam_id:Int){
    getSubjectOrder(exam_id:$exam_id){
        id
        subject
      }
}
`

const FETCH_SUBJECTS_NEETJEE = gql`
query($student_user_exam_id: Int! ,$exam_id:Int){
    getSubjects(student_user_exam_id: $student_user_exam_id exam_id:$exam_id){
        id
        subject
        studentChapters{
          id
          chapter
          class
          enabled
          chapterWisePreviousQuestionsCount
        }
      }
}
`

class ChapterWiseQuestions extends Component {
    constructor(props) {
        super(props)
        this.state = {
            headerBottomImg: {
                type: "eamcet_view",
                title: "PREVIOUS PAPER QUESTIONS"
            },
            toggled: "wrapper sidebar-enable",
            submitError: ""
        }
    }

    menuToggler = () => {
        const toggled = Cookies.get("toggle");
        console.log("mmmmmmmm", toggled)

        if (toggled === "wrapper") {
            this.setState({ toggled: "wrapper sidebar-enable" });
            Cookies.set("toggle", "wrapper sidebar-enable");
        } else {
            this.setState({ toggled: "wrapper" });
            Cookies.set("toggle", "wrapper");
        }
    };
    componentDidMount() {
        this.addStudentAnalytics()
    }
    
    addStudentAnalytics = e => {
        let addStudentObj = ""

        addStudentObj = {
            exam_id: parseInt(Cookies.get("examid")),
            student_user_exam_id: parseInt(Cookies.get("student_user_exam_id")),
            analytics_module_page_id: 245,
            source: 2

        }
        //console.log("addStudentObj", addStudentObj)

        this.submitpt(
            addStudentObj
        ).catch(error => {
            console.log("catch if error");
            console.log(error);
            this.setState({
                submitError: error.graphQLErrors.map(x => x.message)
            });
        });
    }

    submitpt = async (
        params) => {
        await this.props.submitpt({
            variables: {
                params
            },
        });
    };
    render() {

        const getStateChapterNames = this.props.getStateChapterNames
        const loading1 = getStateChapterNames.loading;
        const error = getStateChapterNames.error;

        const getSubjectOrder = this.props.getSubjectOrder
        const loading2 = getSubjectOrder.loading2;
        const error2 = getSubjectOrder.error2;

        const getSubjects = this.props.getSubjects;
        const loading3 = getSubjects.loading;
        const error3 = getSubjects.error


        if (error !== undefined) {
            alert("Server Error. " + error.message);
            return null;
        }

        if (error2 !== undefined) {
            alert("Server Error. " + error2.message);
            return null;
        }

        if (error3 !== undefined) {
            alert("Server Error. " + error3.message);
            return null;
        }

        return (
            <div className={Cookies.get("toggle")}>
                <div className="header-area">
                    <Navbars
                        headerBottom={this.state.headerBottomImg}
                        onClick={() => this.menuToggler()}
                    />                 </div>
                <div className="main-wrapper">
                    <AsideNavbar onClick={() => this.menuToggler()} />
                    <div className="student-overlay" onClick={() => this.menuToggler()} />
                    <div className="content-wrapper" style={{ paddingTop: 10, minHeight: "80vh" }}>
                        {
                            loading1 == true || loading2 == true || loading3 == true ?
                                (
                                    <Container>
                                        <Row>
                                            <Col sm={12}>
                                                <ShimmerLoader />
                                            </Col>
                                        </Row>
                                    </Container>
                                )
                                :
                                (
                                    <ChapterWiseQuestionsSection
                                        getStateChapterNames={getStateChapterNames.getStateChapterNames}
                                        getSubjectOrder={getSubjectOrder.getSubjectOrder}
                                        getSubjects={getSubjects.getSubjects}
                                    />
                                )
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(compose(
    graphql(GET_CHAPTER_NAMES, {
        options: props => ({
            variables: {
                exam_id: parseInt(Cookies.get("examid")),
                student_user_exam_id: parseInt(Cookies.get("student_user_exam_id")),

            },
            fetchPolicy: 'network-only'
        }), name: "getStateChapterNames"
    }),
    graphql(GET_SUBJECTS, {
        options: props => ({
            variables: {
                exam_id: parseInt(Cookies.get("examid")),
            },
            // Static subject ordering for an exam; shared cache entry.
            fetchPolicy: 'cache-first'
        }), name: "getSubjectOrder"
    }),
    graphql(FETCH_SUBJECTS_NEETJEE, {
        options: props => ({
            variables: {
                exam_id: parseInt(Cookies.get("examid")),
                student_user_exam_id: parseInt(Cookies.get("student_user_exam_id"))
            },
            fetchPolicy: 'network-only'
        }), name: "getSubjects"
    }),
    graphql(UPDATE_STUDENT_ANALYTICS, {
        name: "submitpt"
    }),

)(ChapterWiseQuestions));